import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from '@hdms/shared/feature';
import { AssetPathModule } from '@hdms/shared/util-core';

import { HeaderLogoComponent } from './header-logo.component';

@NgModule({
  declarations: [HeaderLogoComponent],
  imports: [CommonModule, AssetPathModule, TranslationModule],
  exports: [HeaderLogoComponent]
})
export class HeaderUILogoModule {}
